import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-snapshot-filter',
  templateUrl: './snapshot-filter.component.html',
  styleUrls: ['./snapshot-filter.component.css']
})
export class SnapshotFilterComponent {
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  @Input() stateList: any = [];
  @Input() validationStatusList: any = [];
  @Input() filterData: any = {};

  filterForm: any = FormGroup;
  defaultFilterValues: any = {
    dateFrom: "",
    dateTo: "",
    state : "",
    validationStatus : "",
    // language: "",
  }
  filterDataObj = {};

  /* stateList = [
    {id: "1", label: "Maharashtra", value: "Maharashtra"},
    {id: "2", label: "Delhi", value: "Delhi"},
    {id: "3", label: "Himachal pradesh", value: "Himachal pradesh"},
    {id: "4", label: "Uttar pradesh", value: "Uttar pradesh"},
  ] */
  /* languageList = [
    {id: "1", label: "Marathi", value: "Marathi"},
    {id: "2", label: "English", value: "English"},
    {id: "3", label: "Hindi", value: "Hindi"},
  ] */
  /* validationStatusList = [
    {id: "1", label: "New", value: "New"},
    {id: "2", label: "Approved", value: "Approved"},
    {id: "3", label: "Pending", value: "Pending"},
    {id: "3", label: "Rejected", value: "Rejected"},
  ] */

  constructor(private fb: FormBuilder,) {
    this.filterForm = this.fb.group(this.defaultFilterValues);
  }

  ngOnInit() {
    console.log(this.filterData, "filterData received")
    
    if (this.filterData.dateFrom && this.filterData.dateTo) {
      this.filterForm.get("dateFrom").setValue(this.filterData.dateFrom)
      this.filterForm.get("dateTo").setValue(this.filterData.dateTo)
    }
    if (this.filterData.state) {
      this.filterForm.get("state").setValue(this.filterData.state);
    }
    if (this.filterData.status) {
      this.filterForm.get("validationStatus").setValue(this.filterData.status);
    }
   /*  if (this.filterData.language) {
      this.filterForm.get("language").setValue(this.filterData.language);
    } */
   
  }


  cancelClick() {
    this.cancel.emit();
  }

  async onSubmit() {
    let filter = {
      dateFrom: this.filterForm.get("dateFrom").value,
      dateTo: this.filterForm.get("dateTo").value,
      state: this.filterForm.get("state").value,
      status: this.filterForm.get("validationStatus").value,
      // language: this.filterForm.get("language").value,
    }
    this.filterDataObj = filter;

    this.passEntry.emit({
      data: this.filterDataObj
    });
  }

  async closeModal() {
    this.close.emit();
  }
 
  async filterReset() {
    this.filterForm.get("dateFrom").setValue("")
    this.filterForm.get("dateTo").setValue("")
    this.filterForm.get("state").setValue("");
    this.filterForm.get("validationStatus").setValue("");
    // this.filterForm.get("language").setValue("")

  }
}
